'use client'

import React from 'react'

import theme from '@/src/config/theme'
import * as UI from '@/src/features/catalog/product-list/product-list-item.styled'
import {Image} from '@/src/shared/ui/image'
import {storeRef} from '@/src/shared/utils/functions'
import {observer} from 'mobx-react'
import {SyncOutlined} from '@ant-design/icons'
import {useProductListItem} from '@/src/features/catalog/product-list/product-list-item.provider'
// @ts-ignore
import productBlurImage from '@/src/shared/assets/media/product-blur.webp'

export const ProductImageLazy = observer(() => {
  const productListItemVM = useProductListItem()

  if (!productListItemVM) throw Error('Product item view model does not found in list')

  return (
    <>
      <Image
        key="img-front"
        fetchPriority="high"
        loading="eager"
        ref={storeRef(productListItemVM.images.imageEvents, 'front')}
        src={productListItemVM.mainImage}
        alt="Кроссовки"
        width={350}
        height={350}
        blurDataURL={productBlurImage.blurDataURL}
        placeholder="blur"
      />

      {productListItemVM.images.imageLoading.mainImage.loading && (
        <UI.ImageLoader
          as={SyncOutlined}
          className="spinner"
          color={theme.colors.primary}
          size={30}
        />
      )}

      {productListItemVM.backImage && (
        <>
          <Image
            key="img-back"
            fetchPriority="high"
            loading="eager"
            ref={storeRef(productListItemVM.images.imageEvents, 'back')}
            src={productListItemVM.backImage}
            alt="Кроссовки"
            width={350}
            height={350}
            data-back="1"
            placeholder="blur"
            blurDataURL={productBlurImage.blurDataURL}
          />

          {productListItemVM.images.imageLoading.backImage.loading && (
            <UI.ImageLoader
              as={SyncOutlined}
              className="spinner"
              color={theme.colors.primary}
              size={30}
              data-back="1"
            />
          )}
        </>
      )}
    </>
  )
})
